
/*@ngInject*/
const RefreshModalController = function ($rootScope, $scope,options, coreConstant) {

    $scope.title = options.title;
    $scope.message = options.message;
    $scope.deleteAll = options.deleteAll;
    $scope.doNotDelete = options.doNotDelete;
    $scope.scoringFormulas = options.scoringFormulas;

    $scope.onDoNotDelete = function () {
        $scope.$close(options.scoringFormulas);

    };

    $scope.onDeleteAll = function () {
        $scope.$close(null);
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

};

angular.module('ums.configuration')
    .controller('refreshModalController', RefreshModalController);

